import { CultureInfo } from '../culture-info.model';
import { CultureInfoSe } from './se';

/**
 * @ignore
 */
export const CultureInfoSeFI: CultureInfo = {
  name: 'se-FI',
  displayName: 'Northern Sami (Finland)',
  iso3LanguageCode: 'sme',
  iso2LanguageCode: 'se',
  ietfLanguageTag: 'se-FI',
  parent: CultureInfoSe
};
